/** PDF / modal address block labels for BOL and border documents (SC-2971). */

export type DocumentAddressLabelPair = {
  shipFromLabel: string;
  shipToLabel: string;
};

const SHIP_FROM_SHIP_TO_LABELS: DocumentAddressLabelPair = {
  shipFromLabel: "SHIP FROM:",
  shipToLabel: "SHIP TO:",
};

const CONSIGNOR_CONSIGNEE_LABELS: DocumentAddressLabelPair = {
  shipFromLabel: "CONSIGNOR:",
  shipToLabel: "CONSIGNEE:",
};

/** Border Canadian PDF section headers (title case with trailing colon). */
export type BorderCanadaAddressSectionLabels = {
  shipFromSectionLabel: string;
  deliverToSectionLabel: string;
};

export const resolveDocumentAddressLabels = (useConsignorConsigneeLabels: boolean): DocumentAddressLabelPair =>
  useConsignorConsigneeLabels ? CONSIGNOR_CONSIGNEE_LABELS : SHIP_FROM_SHIP_TO_LABELS;

export const resolveBorderCanadaAddressSectionLabels = (useConsignorConsigneeLabels: boolean): BorderCanadaAddressSectionLabels =>
  useConsignorConsigneeLabels
    ? { shipFromSectionLabel: "Consignor:", deliverToSectionLabel: "Consignee:" }
    : { shipFromSectionLabel: "Ship From:", deliverToSectionLabel: "Deliver To:" };

/** Create-modal field labels for border Canadian ship-from / deliver-to blocks. */
export const resolveBorderCanadaModalFieldLabels = (useConsignorConsigneeLabels: boolean) => ({
  shipFromName: useConsignorConsigneeLabels ? "Consignor — name" : "Ship from — name",
  shipFromAddress: useConsignorConsigneeLabels ? "Consignor — address" : "Ship from — address",
  deliverTo: useConsignorConsigneeLabels ? "Consignee" : "Deliver to",
});

/** Create-modal label for border U.S. consignee (ship-to) field. */
export const resolveBorderUsConsigneeFieldLabel = (useConsignorConsigneeLabels: boolean): string =>
  useConsignorConsigneeLabels ? "Consignee" : "Consignee (Ship To)";

/** Create BOL modal section header for the ship-from party block (SC-2971 / SC-3182). */
export const resolveBolCreateModalShipFromSectionLabel = (useConsignorConsigneeLabels: boolean): string =>
  useConsignorConsigneeLabels ? "Consignor details" : "Ship From Details";

/** Create BOL modal section header for the ship-to party block (SC-2971). */
export const resolveBolCreateModalShipToSectionLabel = (useConsignorConsigneeLabels: boolean): string =>
  useConsignorConsigneeLabels ? "Consignee details" : "Ship To Details";

/** Lowercase ship-from party term for Create BOL helper copy (third-party pickup). */
export const resolveBolShipFromPartyTerm = (useConsignorConsigneeLabels: boolean): string =>
  useConsignorConsigneeLabels ? "consignor" : "ship-from";
